<template>
  <div>
    <el-dialog title="导出数据" :visible.sync="dlg_export_model" :close-on-click-modal="false" @close="dialogClose"
               @open="openDialog" :modal="dialog_modal" width="600px">
      <el-form label-width="80px" class="pr-3">
        <el-form-item label="导出数量">
          <el-input v-model="pkgForm.total" class="item_w_200 pr-3"></el-input>
          <font v-if="info" color="#ff4500">{{ info }}</font>
        </el-form-item>
        <el-form-item label="订单号">
          <span>{{ pkgForm.traceNo }}</span>
        </el-form-item>
        <el-form-item label="导出内容">
          <el-checkbox-group v-model="pkgForm.type">
            <el-checkbox value="ent" label="工商信息" name="type" style="width:100px;"></el-checkbox>
            <el-checkbox value="staff" label="法人/股东/高管" name="type"></el-checkbox>
            <el-checkbox value="md5" label="MD5广告投放数据包" name="type" style="width:140px;"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <el-form-item label="查看样例">
          <el-switch v-model="pkgForm.delivery"></el-switch>
        </el-form-item>
        <el-form-item v-if="pkgForm.delivery" label="样例文件">
          <a href="" class="pr-4">企业工商信息</a><a href="" class="pr-4">企业高管</a><a href=""
                                                                                         class="pr-4">MD5数据包</a>
        </el-form-item>
        <el-form-item>
          <p>导出数量因数据更新原因可能会上下浮动，以实际导出数量为准。</p>
          <p>总量不足1000条时按10元计费因数据服务的特殊性，服务生效后不支持退款。</p>
          <p>单次导出超过1万条时，只导出前1万条，如需要导出更多，请联系我们的客服人员。</p>
          <p>当数据导出量较大时，导出时间较长，可前往首页 "<a href="/#/user/export"><font color="#ff4500">报告&导出</font></a>"
            查看导出进度。</p>
        </el-form-item>
        <el-form-item label="价格">
          <el-input v-model="pkgForm.totalAmount" class="width_100"></el-input>
        </el-form-item>
        <el-form-item>
          <div v-if="showPayment">
            <el-button type="primary" @click="submitPayment">去支付</el-button>
            <el-button @click="dialogClose">取消</el-button>
          </div>
          <div v-else>
            <el-button type="primary" @click="btn_saveQuery">支付成功</el-button>
            <el-button @click="dialogClose">支付遇到问题</el-button>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import util from "../api/util"
import api from "../api/rest";

export default {
  props: {
    dlg_export_model: Boolean,
    form: {}
  },
  data() {
    return {
      pkgForm: {
        addType: 0,
        fldId: '',
        fldName: '',
        reciveEmail: '',
        count: 1000,
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: ['工商信息', '法人/股东/高管', 'MD5广告投放数据包'],
        resource: '',
        remark: '',
        random: true,
        alipayTraceNo: '',
        subject: '数据导出',
        totalAmount: 0.1,
        traceNo: '',
      },
      page: {
        total: 0,
        index: 0,
        size: 20,
      },
      showPayment: true,
      dialog_modal: false,
      limit: false,
      info: '',
      intervalId: 0
    }
  },
  methods: {
    generateOrderNumber() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');
      const milliseconds = String(now.getMilliseconds()).padStart(3, '0');
      const randomDigits = String(Math.floor(Math.random() * 10000)).padStart(4, '0');
      return `${year}${month}${day}${hours}${minutes}${seconds}${milliseconds}${randomDigits}`;
    },
    openDialog() {
      this.pkgForm.traceNo = this.generateOrderNumber();
      if (this.limit == true && this.form.total > 1000000) {
        this.$message({
          message: "超过100万条数据，导出取消。",
          type: "error",
        });
        this.dialog_modal = false
        this.dialogClose()
      } else {
        this.dialog_modal = true
        this.showPayment = true
        if (this.form.total > 10000) {
          this.pkgForm.total = 10000
          this.pkgForm.totalAmount = 100
          this.info = "总量过1万,导出前1万条"
        } else {
          this.info = ""
          this.pkgForm.total = this.form.total
          this.pkgForm.totalAmount = this.form.totalAmount
        }
      }
    },
    submitPayment() {
      this.showPayment = false;
      const api_url = `/payment/alipay/create?alipayTraceNo=${this.pkgForm.alipayTraceNo}&subject=${encodeURIComponent(this.pkgForm.subject)}&totalAmount=${this.pkgForm.totalAmount}&traceNo=${this.pkgForm.traceNo}`;
      api.remote.doGet(api_url).then(function (response) {
        console.log(response)
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = response; // 插入返回的 HTML 表单
        document.body.appendChild(tempDiv);
        tempDiv.querySelector('form').submit(); // 自动提交表单
      })
    },
    getPayment() {
      let param = {
        traceNo: this.pkgForm.traceNo
      }
      let api_url = '/folder/get_by_name'
      api.remote.doPost(param, api_url).then((res) => {
        console.log(res.defaultFile)
        if (res.defaultFile != null) {
          clearInterval(this.intervalId);
          const href = api.profile.getApiUrl() + res.defaultFile
          console.log(href)
          const a = document.createElement('a');
          a.href = href;
          // a.target = "_blank"
          a.download = 'file.xlsx';
          a.click();
        }
      }).catch((res) => {
        api.handError.action(this, res);
      });
    },
    // 保存搜索命令
    btn_saveQuery() {
      let para = {
        ...this.form,
        ...this.pkgForm,
        ...this.page,
      }
      para.traceNo = this.pkgForm.traceNo
      console.log(para)
      let api_url = '/search/saveQueryOnly'
      api.remote.doPost(para, api_url).then((res) => {
        console.log(res)
        this.$message({
          message: "如自动下载没有执行，请前往'数据中心-导出记录'查看",
          type: "success",
        });
      })
      // 每秒查询一次，是否生成成功，如果生成成功，则自动下载Excel文件
      this.intervalId = setInterval(this.getPayment, 1000);
      // this.dialogClose()
    },
    dialogClose() {
      this.dlg_export_model = false;
      this.$emit("exportClose", this.dlg_export_model);
    }
  },
  mounted() {

  }
}
</script>


// WEBPACK FOOTER //
// ExportData.vue?329152df